import { FeedItemDTO } from '../../feedItems/dtos/FeedItem.dto';
import { TagUtil } from '../../tags/utils/TagUtil';
import { FormsModel } from '../models/Forms.model';
import {
  FormBuilderRequestDTO,
  FormFeedItemType,
  FormRequestDTO,
} from '../types';
import { FormNodeUtil } from './FormNodeUtils';

export class FormsUtil {
  public static mapToViewModel(dto: FeedItemDTO<FormFeedItemType>): FormsModel {
    return {
      id: dto.id,
      headline: dto.headline,
      tagline: dto.tagline,
      coverImage: dto.coverImage,
      emails: dto.feedItem.emails,
      formNodes: dto.feedItem.formNodes
        ? dto.feedItem.formNodes.map((node) =>
            FormNodeUtil.mapToViewModel(node),
          )
        : [],
      access: dto.access,
      status: dto.status,
      tags: dto.tags ? dto.tags.map((tag) => TagUtil.mapToViewModel(tag)) : [],
      publishedOn: dto.publishedOn,
      citationRequired: dto.citationRequired,
      recipients: dto.recipients,
      feedType: 'FormItem',
    };
  }

  public static toRequestDTO(model?: FormsModel): FormRequestDTO {
    return {
      id: model ? model.id : undefined,
      headline: model ? model.headline : '',
      tagline: model ? model.tagline : undefined,
      coverImage: model ? model.coverImage : undefined,
      tags: model ? model.tags : [],
      citationRequired: model ? model.citationRequired : false,
      status: model ? model.status : 'DRAFT',
      formNodes: model
        ? model.formNodes.map((node) => FormNodeUtil.toRequestDTO(node))
        : [],
      emails: model ? model.emails : [],
    };
  }

  public static toBuilderRequestDTO(model?: FormsModel): FormBuilderRequestDTO {
    return {
      formData: this.toRequestDTO(model),
      isInputOver: false,
      isSectionOver: false,
    };
  }

  public static requestDTOToBuilderDTO(
    dto: FormRequestDTO,
  ): FormBuilderRequestDTO {
    return {
      isInputOver: false,
      isSectionOver: false,
      formData: { ...dto },
    };
  }

  public static builderDTOToRequestDTO(
    dto: FormBuilderRequestDTO,
  ): FormRequestDTO {
    return { ...dto.formData };
  }
}
